module.exports = __webpack_public_path__ + "img/top-4-2.6358c63d.jpg";